export default "/fonts/vendor/mdui/dist/roboto/Roboto-ThinItalic.woff?be84e94690a6a2d140485d4d3c74a8e5";